import * as Yup from 'yup';
import { UserEmailData, UserResetPasswordData } from 'src/types/user';
import { AppController } from 'app/controllers';
import { Navigation } from 'app/services/navigation';
import { Routes } from 'src/types/routes';
import { computed, makeObservable } from 'mobx';
import { FlagModel } from '@zajno/common-mobx/viewModels';
import { AppViewModel } from '..';
import { NotificationTypes } from '../components/NotificationsViewModel';

export enum ResetPasswordModes {
    Email = 1,
    Password = 2,
}

export const resetPassValidationSchema: Yup.ObjectSchema<UserResetPasswordData> = Yup.object().shape({
    password: Yup.string().min(6, 'Min 6 chars').required('Password required'),
    confirmPassword: Yup.string().required('Confirm password required').oneOf([Yup.ref('password'), null], 'Passwords must match'),
});

export const resetPassEmailValidationSchema: Yup.ObjectSchema<UserEmailData> = Yup.object().shape({
    email: Yup.string().email("It's not a valid email").required('Email required'),
});

export class ResetPasswordPageViewModel {
    private _isEmailSended = new FlagModel(false);

    constructor() {
        makeObservable(this, {
            mode: computed,
        });
    }

    private get error() { return AppController.Instance.Auth.error; }
    get isLoading() { return AppController.Instance.Auth.isLoading; }
    get isRecovery() { return AppController.Instance.Auth.isLoggedIn; }
    get isEmailSended() { return this._isEmailSended.value; }

    public get mode () {
        if (this.isRecovery) {
            return ResetPasswordModes.Password;
        }

        return ResetPasswordModes.Email;
    }

    submitForm = async <T extends Record<string, string>>(userCredentials: T) => {
        this._isEmailSended.setFalse();
        const { email, password } = userCredentials;

        if (email && this.mode === ResetPasswordModes.Email) {
            await AppController.Instance.Auth.resetPasswordForEmail(email);

            if (this.error) {
                AppViewModel.Instance.notifications.setNotification(this.error, NotificationTypes.error);
                return;
            }

            AppViewModel.Instance.notifications.setNotification('We have sent you an email with the password recovery link.');
        }

        if (password && this.mode === ResetPasswordModes.Password) {
            await AppController.Instance.Auth.updatePassword(password);

            if (this.error) {
                AppViewModel.Instance.notifications.setNotification(this.error, NotificationTypes.error);
                return;
            }

            Navigation.value.push(Routes.Dashboard.Home);
        }
    };

    navigateToTheLogin = () => {
        Navigation.value.push(Routes.Dashboard.Login);
    };
}
